/**
 * Addresses every language shares. Nothing here is translated; the copy in
 * `./en` and `./ar` imports these so a URL is changed in one place.
 */

export const SITE_EMAIL = 'hello@meetnplan.co'

/** Personal data requests, as the Privacy Policy names it. */
export const PRIVACY_EMAIL = 'privacy@meetnplan.co'

/** The product. Paths are the app's own route table (app.meetnplan, src/routes.js). */
export const APP_URL = 'https://app.meetnplan.co'

// The app's sign-in screen also offers creating an organization, so one door
// serves new and existing customers alike.
export const SIGN_IN_URL = `${APP_URL}/login`

/** The app's create-organization wizard; `?plan=<id>` starts it on that plan. */
export const GET_STARTED_URL = `${APP_URL}/get-started`

/** The company behind MeetNPlan. */
export const CODELTD_URL = 'https://codeltd.com'
